import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import FieldInput from 'brastrap/common/field-input/FieldInput';
import FieldSelect from 'brastrap/common/field-select/FieldSelect';
import FieldSet from 'brastrap/common/fieldset/Fieldset';

import { titleOptions } from 'brastrap/common/personal-details-field-set/PersonalDetailsFieldSet';

const messages = defineMessages({
  firstName: {
    id: 'request-magazine.first-name',
    defaultMessage: 'First name',
  },
  lastName: { id: 'request-magazine.last-name', defaultMessage: 'Last name' },
  title: { id: 'request-magazine.title', defaultMessage: 'Title' },
  topTitle: {
    id: 'request-magazine.top-title',
    defaultMessage: 'Your Details',
  },
});

const RequestMagazineFieldSet = props => {
  const { title, firstName, lastName } = props;

  return (
    <FieldSet title={props.intl.formatMessage(messages.topTitle)}>
      <FieldSelect
        {...title}
        label={props.intl.formatMessage(messages.title)}
        hiddenLabel
        options={titleOptions}
        modifiers={['large', 'inline']}
        placeholder={props.intl.formatMessage(messages.title)}
        id="request-magazine-title"
        note={title.error}
      />
      <FieldInput
        {...firstName}
        label={props.intl.formatMessage(messages.firstName)}
        modifiers={['large', 'inline']}
        floatLabel
        required
        id="request-magazine-firstName"
        note={firstName.error}
      />

      <FieldInput
        {...lastName}
        label={props.intl.formatMessage(messages.lastName)}
        modifiers={['large', 'inline']}
        floatLabel
        required
        id="request-magazine-lastName"
        note={lastName.error}
      />
    </FieldSet>
  );
};

RequestMagazineFieldSet.propTypes = {
  title: PropTypes.object,
  firstName: PropTypes.object,
  lastName: PropTypes.object,
  email: PropTypes.object,
  intl: intlShape,
};

export default injectIntl(RequestMagazineFieldSet);
